// src/pinball/components/HighScoreTable.tsx - High score display and entry

import React, { useState } from 'react';
import { HighScoreEntry } from '../types';
import './HighScoreTable.css';

interface HighScoreTableProps {
  scores: HighScoreEntry[];
  currentScore?: number;
  onInitialsSubmit?: (initials: string) => void;
  showInitialsPrompt?: boolean;
}

export const HighScoreTable: React.FC<HighScoreTableProps> = ({
  scores,
  currentScore,
  onInitialsSubmit,
  showInitialsPrompt = false,
}) => {
  const [initials, setInitials] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (initials.length === 3 && onInitialsSubmit) {
      onInitialsSubmit(initials.toUpperCase());
    }
  };

  const handleInitialsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
    setInitials(value);
  };

  return (
    <div className="high-score-table" data-testid="high-score-table">
      <h3>HIGH SCORES</h3>

      {showInitialsPrompt && (
        <form className="initials-form" onSubmit={handleSubmit}>
          <p className="initials-prompt">
            New High Score: {currentScore?.toLocaleString()}!
          </p>
          <div className="initials-input-row">
            <input
              type="text"
              value={initials}
              onChange={handleInitialsChange}
              placeholder="AAA"
              maxLength={3}
              className="initials-input"
              autoFocus
              data-testid="initials-input"
            />
            <button
              type="submit"
              disabled={initials.length !== 3}
              className="initials-submit"
            >
              OK
            </button>
          </div>
        </form>
      )}

      <table className="scores-table">
        <thead>
          <tr>
            <th>#</th>
            <th>NAME</th>
            <th>SCORE</th>
          </tr>
        </thead>
        <tbody>
          {scores.slice(0, 10).map((entry, index) => (
            <tr
              key={index}
              className={currentScore === entry.score ? 'current-score' : ''}
            >
              <td>{index + 1}</td>
              <td>{entry.initials}</td>
              <td>{entry.score.toLocaleString()}</td>
            </tr>
          ))}
          {scores.length === 0 && (
            <tr>
              <td colSpan={3} className="no-scores">No scores yet</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};
